<template>
  <view class="radio-ui-right-demo">
    <view-desc>图标展示在右侧: {{ radioValue }}</view-desc>
    <view class="cube-radio-demos">
      <cube-radio  option="{{ radio1 }}" wx:model="{{ radioValue }}" wx:model-prop="value"></cube-radio>
      <cube-radio  option="{{ radio2 }}" wx:model="{{ radioValue }}" wx:model-prop="value"></cube-radio>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    radio1: {
      text: 'Option1',
      value: 'Option1',
      position: 'right'
    },
    radio2: {
      text: 'Option2',
      value: 'Option2',
      position: 'right'
    },
    radioValue: ''
  }
})
</script>

<style lang="stylus">
// .radio-ui-right-demo
//   .cube-radio-example
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-radio": "@mpxjs/mpx-cube-ui/src/components/radio/index"
    }
  }
</script>
